import React from 'react';
import styled from 'styled-components';
import Icon from './Icon';
import socials from '../socials';

const Side = styled.aside`
  display: none;
  @media (min-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: fixed;
    height: 100vh;
    width: 150px;
    color: #2ea5f0;

    .logo {
      display: flex;
      justify-content: center;
      color: #35a16d;
      &:hover{
        cursor: pointer;
      }
    }

    ul {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      padding: 0;
      margin: 0;
      gap: 30px;
      list-style: none;
    }

    a {
      text-decoration: none;
    }

    ul::after {
      content: '';
      display: block;
      width: 3px;
      height: 100px;
      background-color: #cec6ca;
      border-radius: 2px;
      margin-top: 0px;
      transition: all 100ms linear 0s;
    }
    svg {
      color: #cec6ca;
      width: 20px;
      height: 20px;
      transition: all 300ms linear 0s;
      &:hover {
        cursor: pointer;
        transform: translateY(-5px);
        color: #35a16d;
      }
    }
  }
`;

function Sidebar() {
  return (
    <Side>
      <div className="logo">
        <h3>&lt;k/&gt;</h3>
      </div>
      <div className="soc-ver">
        <ul>
          {socials.map(({ url, name }) => (
            <li key={name}>
              <a href={url} target="_blank" rel="noopener noreferrer">
                <Icon name={`${name}`} />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </Side>
  );
}

export default Sidebar;
